import React from 'react'
import './wavesStyle.css'
import WaveIcon from './WaveIcon'
import {TextField} from '@mui/material';


const WavesForm = () => {

  const isMobile = window.innerWidth < 768; 
  return (<>
    <div className="header">
    <div className="flex flex-wrap justify-around items-center w-full">
      <div className="text-continer flex flex-col gap-10 w-full md:w-3/4 p-5">
        <h2>Logra que tu organización se sienta en buenas manos</h2>
        <h6 className='text-center'>En <b>Jahn Institute</b> estamos listos para ayudarte
         a visibilizar tu autoridad. Es momento de <b>transformar a las personas en líderes 
          comprometidos, resilientes y con menos deseos de irse para fortalecer a tu empresa.</b>
          </h6>
      </div>
      <div className='form-container px-2 md:px-10 flex flex-col gap-5'>
      <div className='flex flex-wrap justify-center items-center gap-3 w-full'>
        <TextField
          id="outlined-basic"
          label="Nombre"
          variant="outlined"
          sx={{ m: 1, width: isMobile ? '100%' : '40ch' }} // Set width to 100% on mobile, otherwise 40ch
        />
        <TextField
          id="outlined-basic"
          label="Correo"
          variant="outlined"
          sx={{ m: 1, width: isMobile ? '100%' : '40ch' }} // Set width to 100% on mobile, otherwise 40ch
        />
    </div>
        <TextField
          id="outlined-multiline-static"
          label="Mensaje"
          multiline
          rows={5}
          sx={{ m: 1, width: isMobile ? '100%' : '82ch' }} // Set width to 100% on mobile, otherwise 40ch
          defaultValue="Mensaje"
        />  
      </div>
      <div className="w-full py-5">
          <button className='button-23 '>Contactar</button>
        </div>
    </div>
    <div>
       <WaveIcon/>
    </div>
    </div>
  </>
  )
}

export default WavesForm